import { render, staticRenderFns } from "./PdfDownload.vue?vue&type=template&id=2d7f73b6&scoped=true"
import script from "./PdfDownload.vue?vue&type=script&lang=js"
export * from "./PdfDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7f73b6",
  null
  
)

export default component.exports